import * as dateFormat from "dateformat";
import Utils from "./Utils";

const MILIS_IN_ONE_SEC = 1000;
const SECS_IN_ONE_MINUTE = 60;
const MINS_IN_ONE_HOUR = 60;

const MILIS_IN_ONE_MINUTE = MILIS_IN_ONE_SEC * SECS_IN_ONE_MINUTE;
const MILIS_IN_ONE_HOUR = MILIS_IN_ONE_MINUTE * MINS_IN_ONE_HOUR;

export default class DateUtils {
  public static format(date: Date) {
    return dateFormat(date, "mm/dd/yy");
  }

  public static longFormat(date: Date) {
    return dateFormat(date, "dddd, mmmm dS, yyyy, h:MM:ss TT");
  }

  public static timeFromNow(futureDate: Date) {
    const now = Date.now();
    if (now > futureDate.getTime()) {
      return DateUtils.longFormat(futureDate);
    } else {
      const timeDiff = futureDate.getTime() - now;
      const hoursFromNow = Math.round(timeDiff / MILIS_IN_ONE_HOUR);
      const minutesFromNow = Math.round(timeDiff / MILIS_IN_ONE_MINUTE);

      if (hoursFromNow > 0) {
        return Utils.pluralCounterString(hoursFromNow, "hour");
      } else if (minutesFromNow > 0) {
        return Utils.pluralCounterString(minutesFromNow, "minute");
      } else {
        return "Now";
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/utils/DateUtils.ts